export default __webpack_public_path__ + "static/media/cslogo.333146a3.svg";